import React, { ForwardedRef } from "react";

import { MeetingSessionMediaState, MeetingSessionStatus } from "@kalyzee/kast-web-sdk/http";
import { Meeting, MeetingSession, MeetingSessionMedia } from "@kalyzee/kast-web-sdk/websocket";
import { getFormattedUserFromMeetingSession } from "../../helpers/meeting";

import styles from "./MeetingPlayerDataOverlay.module.css";
import { UserAvatar } from "@kalyzee/kast-web-sdk/web-components";
import { getNormalUser } from "../../helpers/user";

export interface MeetingPlayerDataOverlayProps {
  meeting?: Meeting;
  session?: MeetingSession;
  mediaSession?: MeetingSessionMedia;
  mediaStream?: MediaStream;
  videoIsDisabled?: boolean;
  videoIsReady?: boolean;
  style?: React.CSSProperties;
  className?: string;
}

export interface MeetingPlayerDataOverlayRef {}

export const MeetingPlayerDataOverlay = React.forwardRef(
  (
    { meeting, session, mediaSession, mediaStream, videoIsDisabled, videoIsReady, style, className }: MeetingPlayerDataOverlayProps,
    forwardRef: ForwardedRef<MeetingPlayerDataOverlayRef>
  ) => {
    if (!meeting || !session) return null;
    const { avatar, displayName } = session.user ? getNormalUser(session.user) : { avatar: undefined, displayName: undefined };
    let message = "Impossible de récupérer le flux vidéo.";
    if (session?.status !== MeetingSessionStatus.RUNNING) {
      message = "Déconnecté";
    } else {
      if (!mediaSession) {
        message = "Aucun média";
      } else {
        if ([MeetingSessionMediaState.WAITING, MeetingSessionMediaState.CAPTURING].includes(mediaSession.state)) {
          message = "Préparation du flux vidéo.";
        }
        if (mediaSession.state === MeetingSessionMediaState.PUBLISHING) {
          message = "Publication en cours...";
        }
        if (mediaSession.state === MeetingSessionMediaState.READY) {
          if (mediaStream) {
            /*
            if (!videoIsReady) {
              return <Loading style={{ position: "absolute", top: 0, left: 0, backgroundColor: "#00000066", width: "100%", height: "100%" }} />;
            }
            */
            if (!mediaSession.video.enabled) {
              message = "La caméra est désactivée";
            } else if (videoIsDisabled) return <div className={styles.notReadyOverlay} />;
            else return null;
            if (videoIsReady || true) {
              if (!mediaSession.video.enabled) {
                message = "La caméra est désactivée";
              } else if (videoIsDisabled) return <div className={styles.notReadyOverlay} />;
              else return null;
            }
          } else {
            message = "Récupération en cours...";
          }
        }
      }
    }
    return (
      <div className={`${styles.container} ${className}`} style={style}>
        <UserAvatar style={{ width: "60px", height: "60px" }} image={avatar} username={displayName} />
        {message}
      </div>
    );
  }
);
